module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_2-134fd7a335e762918338c1b111e30e10.webp";